import { postJson } from '../../http'

export default {
    // 安全设置-绑定邮箱
    bindEmailUrl() {
        return '/lz/account/userSafety/bindEmail'
    },
    bindEmail(data) {
        return postJson('/lz/account/userSafety/bindEmail', data)
    },
    // 安全设置-绑定手机
    bindMobileUrl() {
        return '/lz/account/userSafety/bindMobile'
    },
    bindMobile(data) {
        return postJson('/lz/account/userSafety/bindMobile', data)
    },
    // 校验绑定邮箱
    checkEmail(data) {
        return postJson('/lz/account/userSafety/checkEmail', data)
    },
    // 校验绑定手机
    checkMobile(data) {
        return postJson('/lz/account/userSafety/checkMobile', data)
    },
    // 发送邮箱验证码 type: 0 激活 1验证 2绑定 
    sendEmailCodeUrl() {
        return '/lz/account/userSafety/sendEmailCode'
    },
    sendEmailCode(data) {
        return postJson('/lz/account/userSafety/sendEmailCode', data)
    },
    // 发送手机验证码 type: 0 激活 1验证 2绑定 
    sendMobileVCodeUrl() {
        return '/lz/account/userSafety/sendMobileVCode'
    },
    sendMobileVCode(data) {
        return postJson('/lz/account/userSafety/sendMobileVCode', data)
    },
    /**
     * 校验手机验证码是否正确
     *
     * @param {*} data
     * @returns
     */
    checkMobileVCode(data) {
        return postJson('/lz/account/userSafety/checkMobileCode', data)
    },
    /**
     * 校验邮箱验证码是否正确
     *
     * @param {*} data
     * @returns
     */
    checkEmailVCode(data) {
        return postJson('/lz/account/userSafety/checkEmailCode', data)
    },
    /**
     * 发送验证码（不需要登录）
     *
     * @param {*} data
     * @returns
     */
    sendMobileVCodeNoLogin(data) {
        return postJson('/lz/account/passport/sendMobileVCode', data)
    },
    /**
     * 校验手机号（不需要登录）
     *
     * @param {*} data
     * @returns
     */
    checkMobileNoLogin(data) {
        return postJson('/lz/account/passport/checkMobile', data)
    },
    /**
     * 校验手机验证码是否正确（不需要登录）
     *
     * @param {*} data
     * @returns
     */
    checkMobileVCodeNoLogin(data) {
        return postJson('/lz/account/passport/regCheckMobileCode', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/user/security.js